<template lang="pug">
  .edit-platform-form.columns
    b-loading(:active="isLoading")

    .column.is-6: .box
      b-field(label="Сервер*")
        b-select(v-model="value.server_id")
          option(v-for="(server, key) in servers.items" :value="server.id" :key="server.id")
            | {{ server.name }}

      b-field(label="Статус платформы*")
        b-select(v-model="value.status")
          option(v-for="(status, key) in value.statusList" :value="key" :key="key")
            | {{ status.name }}

      p
        | При отключении платформы все администраторы переводятся в архив. Активизация платформы на администраторов не влияет.

      b-field(label="Приоритет")
        b-select(v-model="value.priority")
          option(v-for="(priority, key) in ['1 Высокий', '2 Средний', '3 Низкий']" :value="key+1" :key="key+1")
            | {{ priority }}

      b-field(label="Название*", :type="errors && errors.name ? 'is-danger' : ''", :message="errors.name")
        b-input(v-model="value.name")
      b-field(label="Компания*", :type="errors && errors.company ? 'is-danger' : ''", :message="errors.company")
        b-input(v-model="value.company")
      b-field(label="URL*", :type="errors && errors.host ? 'is-danger' : ''", :message="errors.host")
        b-input(v-model="value.host")

</template>

<script>
import { mapGetters } from 'vuex';
import BSelect from 'buefy/src/components/select/Select';
import SelectRole from '../components/SelectRole';
import { genPassword } from '../helpers/string';
import Server from "../models/Server";

export default {
  name: 'new-platform-form',
  components: { SelectRole, BSelect },
  props: {
    value: Object,
    errors: Object,
  },

  data: () => ({
    isLoading: true,
    label: null,
    servers: Server.collection(),
  }),

  computed: {
    ...mapGetters(['user']),
  },

  watch: {
    $route() {
      this.loadServers();
    },
  },

  methods: {
    loadServers() {
      this.servers.$fetch({
        scope: 'active:' + this.value.server_id,
      });
    },
  },

  created() {
    this.loadServers();
    this.isLoading = false;
  },
};
</script>
